module.exports = __webpack_public_path__ + "img/ambulanceH.ff0a2023.png";